import { render, staticRenderFns } from "./BigDownloadButton.vue?vue&type=template&id=7a0458c6&scoped=true"
import script from "./BigDownloadButton.vue?vue&type=script&lang=ts"
export * from "./BigDownloadButton.vue?vue&type=script&lang=ts"
import style0 from "./BigDownloadButton.vue?vue&type=style&index=0&id=7a0458c6&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a0458c6",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/winfakt/wf/v2.online.dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7a0458c6')) {
      api.createRecord('7a0458c6', component.options)
    } else {
      api.reload('7a0458c6', component.options)
    }
    module.hot.accept("./BigDownloadButton.vue?vue&type=template&id=7a0458c6&scoped=true", function () {
      api.rerender('7a0458c6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/common/BigDownloadButton.vue"
export default component.exports